var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWineGlassEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17,0H7c-1.654,0-3,1.346-3,3v6.706c0,4.178,3.077,7.716,7,8.23v4.064h-3c-.552,0-1,.447-1,1s.448,1,1,1h8c.552,0,1-.447,1-1s-.448-1-1-1h-3v-4.061c1.716-.212,3.306-.969,4.571-2.197,1.566-1.521,2.429-3.56,2.429-5.742V3c0-1.654-1.346-3-3-3Zm1,10c0,1.637-.647,3.166-1.822,4.307-1.174,1.14-2.731,1.732-4.363,1.69-3.207-.096-5.815-2.918-5.815-6.291V3c0-.552.449-1,1-1h10c.551,0,1,.448,1,1v7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineGlassEmpty);
export default __webpack_public_path__ + "static/media/wine-glass-empty.1658d6d69a98716bb65925249afb6309.svg";
export { ForwardRef as ReactComponent };